import { TabBookingAbstract } from './tabBookingAbstract'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { poItemsUpdate } from '@/api/seaExport/poItems'
import { PoItems } from '@/class/model/booking/PoItems'
import { poItems } from '@/api/seaExport/poItems'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { cache } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { jdySendPoItems, jdyUnlockStatus, queryCarrierCodeFunc } from '@/api/seaExport/seaExportJob'
import { getLoading } from '@/utils/utilBaseElement'

export class TabTradeDetailBase extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.$message = this.view.$message
    this.$confirm = this.view.$confirm
    this.$refs = this.view.$refs
    this.$store = this.view.$store
    this.$i18n = this.view.$i18n
    this.$emit = this.view.$emit
    this.view.$t = this.view.$t
    this.$checkPermission = this.view.$checkPermission
  }

  get context() {
    return this.view.context
  }

  set context(context) {
    this.view.context = context
  }

  get user() {
    return this.view.context.user
  }

  set user(user) {
    this.view.context.user = user
  }

  get config() {
    return this.view.config
  }

  set config(config) {
    this.view.config = config
  }

  get job() {
    return this.view.job
  }

  set job(job) {
    this.view.job = job
  }

  get poItems() {
    return this.view.poItems
  }

  set poItems(poItems) {
    this.view.poItems = poItems
  }

  get delPoItemsUuids() {
    return this.view.delPoItemsUuids
  }

  set delPoItemsUuids(delPoItemsUuids) {
    this.view.delPoItemsUuids = delPoItemsUuids
  }

  async loadPoItems(isRefresh = false) {
    // 加载数据
    const job = new SeaExportJob(this.job)

    // 添加/移除装箱 需要强制刷新grid
    if (isRefresh) {
      job.poItems = ''
      job.containerUsages = ''
    }

    await Promise.all([
      job.getPoItems(),
      job.getContainerUsages()
    ])
    this.poItems = this.job.poItems && this.job.poItems.length > 0 ? this.job.poItems.sort((a, b) => {
      return a.sequenceNo - b.sequenceNo
    }) : []
    this.sumQuantiyWeightCubage()
  }

  // 合计件毛体
  sumQuantiyWeightCubage() {
    this.view.totalQuantity = 0
    this.view.totalWeight = 0
    this.view.totalCubage = 0
    for (const poItem of this.poItems) {
      this.view.totalQuantity += Number(poItem.quantity) || 0
      this.view.totalWeight += Number(poItem.grossWeight) || 0
      this.view.totalCubage += Number(poItem.cubage) || 0
    }
  }

  // 新增
  addBtnClickHandler() {
    const poItems = new PoItems().fillDefaultValue().getData()
    poItems.purchaseCurrency = 'USD'
    poItems.deviceStatus = 0
    poItems.productiveYear = '不详'
    poItems.newOrUsed = ''
    poItems.jobUuid = this.job.uuid
    poItems.sequenceNo = this.poItems.length > 0 ? this.poItems.length + 1 : 1
    poItems.cargoType = this.job.cargoType || 'GC'
    if (this.poItems) {
      if (this.poItems.length > 0) {
        const lastPoItems = this.poItems[0]
        if (lastPoItems) { poItems.purchaseCurrency = lastPoItems.purchaseCurrency }
      }
    }
    this.poItems.push(poItems)
    // gird 刷新
    // this.view.$nextTick(() => {
    //   this.view.gridApi.refreshCells({ force: true })
    // })
  }
  // 删除
  delBtnClickHandler() {
    const selections = this.view.gridApi.getSelectedRows()
    if (selections.length > 0) {
      for (const item of selections) {
        if (item.uuid) {
          this.delPoItemsUuids.push(item.uuid)
        }
        const index = this.poItems.findIndex(p => p === item)
        this.poItems.splice(index, 1)
        this.updateSequenceNo(item.sequenceNo)
      }
    }
  }
  // button click 关联装箱信息
  relatedContainerHandler() {
    // 获取选中项
    var selPoItems = this.view.gridApi.getSelectedRows()

    if (selPoItems == null || selPoItems.length === 0) {
      this.$message.warning(this.view.$t('Message.CargoDetailsIsNotSelected'))
      return
    } else {
      for (const item of selPoItems) {
        if (item.related === 1) {
          this.$message.warning(this.view.$t('Message.PleaseSelectUnRelatedTradeDetailData'))
          return
        }
      }
    }
    const containerUsageKeys = []
    for (const keyItem of this.poItems) {
      if (keyItem.containerUsageKey && !containerUsageKeys.includes(keyItem.containerUsageKey)) {
        containerUsageKeys.push(keyItem.containerUsageKey)
      }
    }
    this.view.tradeDetailContainerLinkedDialog.selPoItems = selPoItems
    this.view.tradeDetailContainerLinkedDialog.relatedContainerUsage = containerUsageKeys
    this.view.tradeDetailContainerLinkedDialog.visible = true
  }
  // 关联装箱信息 处理
  async linkUsagesEventHandler(data) {
    const linkedContainerUsage = data
    const selectedPoItems = this.view.gridApi.getSelectedRows()
    let updateFlag = false
    if (selectedPoItems && selectedPoItems.length > 0) {
      for (const item of selectedPoItems) {
        if (linkedContainerUsage.container) {
          if (item.containerNo !== linkedContainerUsage.container.containerNo) {
            updateFlag = true
          }
          item.eqSize = linkedContainerUsage.container.eqSize
          item.eqType = linkedContainerUsage.container.eqType
          item.containerNo = linkedContainerUsage.container.containerNo
          item.sealNo = linkedContainerUsage.container.sealNo
          item.related = 1
          item.containerUsageKey = linkedContainerUsage.uuid
        }
      }
      await poItemsUpdate(selectedPoItems)
      if (updateFlag) {
        this.view.sendToPlatformUnlock = true
        this.job.lockStatus = true
      }
      this.$message.success(this.view.$t('Message.OperationSuccessfully'))
      // 刷新grid
      this.loadPoItems(true)
    }
  }

  /**
   * CARGO-30757 货物明细 导入模板新增字段
   * 客户做过货物明细导入，业务大保存后自动关联装箱信息
   */
  async autoRelatedContainer() {
    this.poItems = await poItems({ jobUuid: this.job.uuid }).then(res => res.data)
    if (!this.poItems || this.poItems.length <= 0) return
    const items = [] // 需要关联的货物明细
    const relatedContainerUsage = [] // 已关联的箱子排除掉
    for (const item of this.poItems) {
      if (item.containerUsageKey && !relatedContainerUsage.includes(item.containerUsageKey)) {
        relatedContainerUsage.push(item.containerUsageKey)
      }
      if (item.related || item.containerUsageKey) { // 已关联或者不是导入的就排除掉
        continue
      }
      items.push(item)
    }

    if (!this.job.containerUsages || this.job.containerUsages.length <= 0) {
      await new SeaExportJob(this.job).getContainerUsages()
    }
    if (items && items.length > 0 && this.job.containerUsages && this.job.containerUsages.length > 0) {
      const needUpdate = []
      for (const item of items) {
        const eqSize = item.eqSize
        const eqType = item.eqType
        const containerNo = item.containerNo
        const sealNo = item.sealNo
        if (!eqSize || !eqType || !containerNo || !sealNo) {
          continue
        }
        for (const usage of this.job.containerUsages) {
          if (relatedContainerUsage.includes(usage.uuid)) { // 排除之前已装箱的箱子
            continue
          }
          const container = usage.container
          if (!container || !container.eqSize || !container.eqType || !container.containerNo || !container.sealNo) {
            continue
          }
          // 根据箱型箱种箱号封号进行匹配，一致的就自动关联箱子
          if (eqSize === container.eqSize && eqType === container.eqType && containerNo === container.containerNo && sealNo === container.sealNo) {
            item.related = 1
            item.containerUsageKey = usage.uuid
            needUpdate.push(item)
          }
        }
      }
      if (needUpdate.length <= 0) return
      poItemsUpdate(needUpdate).then(res => {
        // 刷新grid
        this.loadPoItems(true)
      })
    }
  }

  /**
   * button click 移除关联
   */
  removeRelatedContainerHandler() {
    const selTrades = this.view.gridApi.getSelectedRows()
    if (selTrades == null || selTrades.length === 0) {
      this.$message.warning(this.view.$t('Message.PleaseSelectData'))
      return
    } else if (selTrades.length > 1) {
      this.$message.warning(this.view.$t('Message.OnlySelectOneData'))
      return
    } else {
      const sel = selTrades[0]
      const selContainerUsageKey = sel.containerUsageKey
      const datas = this.poItems
      if (!sel.containerUsageKey) {
        this.$message.warning(this.view.$t('Message.NoAssociatedContainerInfo'))
        return
      }
      let updateFlag = false
      const associatePoItems = []
      this.$confirm(this.view.$t('SeaExport.ConatainerNoRemoveRelation').replace('{0}', sel.containerNo), this.view.$t('common.tips.prompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        for (const poItem of datas) {
          if (poItem.containerUsageKey === selContainerUsageKey) {
            if (poItem.containerNo) {
              updateFlag = true
            }
            poItem.eqSize = null
            poItem.eqType = null
            poItem.containerNo = null
            poItem.sealNo = null
            poItem.related = 0
            poItem.containerUsageKey = null
            associatePoItems.push(poItem)
          }
        }
        if (associatePoItems && associatePoItems.length > 0) {
          await poItemsUpdate(associatePoItems)
          this.$message.success(this.view.$t('Message.RemovedSuccesfully'))
          if (updateFlag) {
            this.view.sendToPlatformUnlock = true
            this.job.lockStatus = true
          }
          // 刷新grid
          this.loadPoItems(true)
        }
      })
    }
  }

  /**
   * 下载模板
   */
  downTemplateBtn_clickHandler() {
    const fileName = 'PoItemsImportTemplate.xls'
    const folderName = 'price'
    ExportUtils.downloadTemplateFile(fileName, folderName)
  }
  //  excel 导入后逻辑处理
  onImportSucceeded(data) {
    // let count = 0
    // if (data && data.length > 0) {
    //   if (this.job) {
    //     count = data.length
    //     for (const item of data) {
    //       item.sequenceNo = this.poItems.length + 1
    //       this.poItems.push(item)
    //     }
    //   }
    // }
    const resultDocumentId = data.resultDocumentId
    const successRow = data.successRow
    const errorRow = data.errorRow
    const poItemsList = data.poItemsList
    if (poItemsList && poItemsList.length > 0) {
      this.view.isAutoRelatedContainer = true
      for (const item of poItemsList) {
        item.isAutoRelatedContainer = true
        item.sequenceNo = this.poItems.length + 1
        if (!item.cargoType) {
          item.cargoType = this.job.cargoType
        }
        this.poItems.push(item)
      }
    }
    const storageURL = cache.config.get('StorageURL')
    console.log('storageURL -------------- ' + storageURL)
    const url = `${URL.common.findByFileId}/${resultDocumentId}?sessionId=${this.$store.getters.userInfo.sessionId}`
    if (errorRow > 0) {
      this.$confirm(this.view.$t('Message.ImportSuccessful1') + successRow + `${this.view.$t('CargoMsg.Cargo_Pcst')}，${this.view.$t('Message.Failure')}` + errorRow + `${this.view.$t('CargoMsg.Cargo_Pcst')}，${this.view.$t('SeaExport.ReImportAfterModification')}` +
        '<br><a href="' + url + `" target="_blank" style="color:#46a6ff" >${this.view.$t('SeaExport.FailedToDownloadData')}</a>`, this.view.$t('common.tips.systemPrompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        closeOnClickModal: false
      }).then(() => {}).catch(() => {})
    }
    // this.$message.success(this.view.$t('Message.ImportSuccessful1') + count + this.view.$t('Message.ImportSuccessful2'))
  }
  /**
   * Excel 导出
   */
  exportBtnClickHandler() {
    if (!this.view.poItems || this.view.poItems.length <= 0) {
      this.$message.warning(this.view.$t('Message.NoData')) // 判断列表是否有数据
      return
    }
    const rows = this.view.gridApi.getSelectedRows()
    if (rows.length === 0) {
      this.$message.warning(this.view.$t('Message.SelectTheData')) // 判断是否选中数据
      return
    }
    const allDisplayedColumns = this.view.gridOptions.columnApi.getAllDisplayedColumns()
    const fileName = '海运出口货物明细'
    exportExcel(fileName, rows, allDisplayedColumns)
  }
  /**
   * 打印
   */
  onBatchPrint() {
    const selectedPoItems = this.view.gridApi.getSelectedRows()
    if (selectedPoItems.length === 0) {
      this.$message.warning(this.view.$t('Message.CargoDetailsIsNotSelected'))
      return
    }
    const uids = Array.from(selectedPoItems, j => j.uuid)
    if (uids.length > 0) {
      this.view.templateSelectorDialog.cxt = new SeaExportJob(this.view.job)
      this.view.templateSelectorDialog.data = { 'POITEMS_UUID': uids }
      this.view.templateSelectorDialog.category = 'SEPOITEMS'
      this.view.templateSelectorDialog.visible = true
      // TemplateSelectorWin.getInstance().showThisWin(job, "SEPOITEMS", {"POITEMS_UUID":uids}, this);
    }
  }
  // 发送信息对接到简道云平台
  async sendToJdyPlatform() {
    const jobUuids = []
    jobUuids.push(this.job.uuid)
    const branchId = this.$store.getters.currentOfficeId
    const loading = getLoading()
    await jdySendPoItems({ branchId: branchId, jobUuids: jobUuids }).then(res => {
      const data = res.data
      if (data && data.successNum === 0 && data.failNum === 0) {
        this.$message.warning(this.view.$t('Message.NoSendingGoodsInfo'))
        return
      }
      if (data && data.successNum && data.failNum === 0) {
        this.$message.success(this.view.$t('Message.SuccessfullySent'))
        return
      }
      if (data && data.failNum) {
        const failList = data.jdyPoItemFailVOS || []
        let errorMessage = this.view.$t('SeaExport.sendFailInfo').replace('{0}', data.successNum).replace('{1}', data.failNum) + `<br>`
        failList.forEach((failItem, index) => {
          errorMessage += `${index + 1}. ` + this.view.$t('Clearing.BusinessNumber') + `：${failItem.jobNo} Order NO：${failItem.orderNo} ItemNO：${failItem.itemNo}` + this.view.$t('CargoMsg.Cargo_ResultMessage') + `: ${failItem.reason}<br>`
        })
        this.$message.warning({
          message: errorMessage,
          dangerouslyUseHTMLString: true
        })
      }
    }).finally(() => {
      loading.close()
    })
    // 刷新grid
    await this.loadPoItems(true)
  }
  async sendToPlatformUnlock() {
    this.view.sendToPlatformUnlock = false
    this.job.lockStatus = false
    const jobUuids = []
    jobUuids.push(this.job.uuid)
    const loading = getLoading()
    await jdyUnlockStatus(jobUuids).then(res => {
      this.$message.success(this.view.$t('CargoMsg.Cargo_UnLockLabel') + this.view.$t('CargoMsg.Cargo_Success'))
    }).finally(() => {
      loading.close()
    })
    this.view.gridApi.refreshCells({ force: true })
  }
  // 修改每行序列号
  updateSequenceNo(sequenceNo) {
    const poItems = this.poItems
    if (poItems && poItems.length > 0) {
      for (const item of poItems) {
        if (item.sequenceNo > sequenceNo) {
          item.sequenceNo = item.sequenceNo - 1
        }
      }
    }
  }
}
